(() => {
  class DynamicRichText extends HTMLElement {
    constructor() {
      super();
      this.images = [];
      this.observer = null;
    }

    connectedCallback() {
      this.images = Array.from(this.querySelectorAll('[data-drt-image]'));

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.classList.add('dynamic-rich-text__image--visible');
              } else {
                entry.target.classList.remove('dynamic-rich-text__image--visible');
              }
            });
          },
          {
            rootMargin: '-10% 0px -10% 0px',
            threshold: 0.15,
          }
        );

        this.images.forEach((image) => this.observer.observe(image));
      } else {
        this.images.forEach((image) =>
          image.classList.add('dynamic-rich-text__image--visible')
        );
      }

      if (Shopify && Shopify.designMode) {
        this.addEventListener('shopify:block:select', (e) => {
          const target = e.target.closest('[data-drt-image]');
          if (target) {
            target.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        });
      }
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
    }
  }

  if (!customElements.get('dynamic-rich-text')) {
    customElements.define('dynamic-rich-text', DynamicRichText);
  }
})();